import { ButtonERP } from "@finanedi.es/storybook"
import { TFunction } from "i18next"
import { Dropdown, DropdownChangeParams } from "primereact/dropdown"
import { Skeleton } from "primereact/skeleton"
import { frontendCurrency } from "utils/formatCurrency"

interface ModeloAnualProps {
  t: TFunction
  year: {
    selectedYear: string
  }
  handleYearSelection: (e: DropdownChangeParams) => void
  yearsOptionList: string[] | undefined
  navigateDeclaracion?: () => void
  navigate?: () => void
  isLoading: boolean
  data:
    | {
        text: string
        value?: number
        currencyFormat: boolean
      }[]
    | undefined
  isModelo347?: boolean
}

const ModeloAnual = ({
  t,
  year,
  handleYearSelection,
  yearsOptionList,
  navigateDeclaracion,
  navigate,
  isLoading,
  data,
  isModelo347 = false,
}: ModeloAnualProps) => {
  return (
    <>
      <div className='tw-pt-4 tw-flex tw-flex-col tw-items-center '>
        <div className='tw-w-140'>
          <div className='tw-py-3 tw-my-[1px] tw-text-right'>
            <Dropdown
              id='rangosFechaIvaImpuesto'
              name='rangosFechaivaImpuesto'
              className='tw-rounded-md'
              value={year.selectedYear}
              options={yearsOptionList}
              onChange={handleYearSelection}
            />
          </div>
          <div
            className={`tw-bg-white tw-p-6 tw-border tw-border-solid tw-rounded-lg tw-shadow-md tw-flex tw-flex-col tw-justify-end ${
              isModelo347 ? "tw-h-83.5" : "tw-h-70"
            }`}
          >
            <div className='tw-h-full tw-space-y-4'>
              {isLoading ? (
                <div className='tw-h-full tw-flex tw-justify-center tw-items-center'>
                  <Skeleton
                    width='200px'
                    height='20px'
                  />
                </div>
              ) : (
                data?.map(
                  (item: {
                    text: string
                    value?: number
                    currencyFormat: boolean
                  }) => {
                    return (
                      <div
                        key={item.text}
                        className='tw-p-2 tw-border tw-border-solid tw-rounded-lg tw-grid tw-grid-cols-[auto_150px]'
                      >
                        <span className='tw-text-sm tw-justify-self-start tw-text-left'>
                          {item.text}
                        </span>
                        <span className='tw-text-sm tw-whitespace-nowrap tw-justify-self-end tw-self-center tw-font-medium'>
                          {isLoading ? (
                            <Skeleton
                              width='80px'
                              height='15px'
                            />
                          ) : item.currencyFormat ? (
                            frontendCurrency(item.value ?? 0)
                          ) : (
                            item.value ?? 0
                          )}
                        </span>
                      </div>
                    )
                  }
                )
              )}
            </div>
            <div className='tw-flex tw-justify-center tw-pt-6 tw-gap-4'>
              <ButtonERP
                customize={{
                  type: "primary",
                  size: "md",
                }}
                icon={
                  <img
                    src='/img/aeat_icon.svg'
                    alt='AEAT'
                    className='tw-h-4 tw-w-4'
                  />
                }
                onClick={navigateDeclaracion}
                label={String(t("taxSummary.table190DeclarationBtn"))}
              />
              <ButtonERP
                customize={{
                  type: "white",
                  size: "md",
                }}
                onClick={navigate}
                label={String(t("taxSummary.table190YearlyBtn"))}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ModeloAnual
